// extracted by mini-css-extract-plugin
export var card_topic = "contact_card-module--card_topic--MmYSN";
export var details = "contact_card-module--details--IQ-eu";
export var icon_list = "contact_card-module--icon_list--9qiTI";
export var icon = "contact_card-module--icon--zjNpY";